document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-variant-select]')) return;
  const select = event.target;
  const option = select.selectedOptions[0];
  const section = select.closest('.product-section');
  const price = section.querySelector('[data-product-price]');
  const button = section.querySelector('[name="add"]');
  price.replaceChildren(document.createTextNode(option.dataset.price + ' '));
  if (option.dataset.compare) {
    const compare = document.createElement('s');
    compare.textContent = option.dataset.compare;
    price.append(compare);
  }
  button.disabled = option.dataset.available !== 'true';
  button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
  const quantity = section.querySelector('[name="quantity"]');
  quantity.min = option.dataset.min;
  quantity.step = option.dataset.step;
  if (option.dataset.max) quantity.max = option.dataset.max;
  else quantity.removeAttribute('max');
  quantity.value = option.dataset.min;
  const url = new URL(location.href);
  url.searchParams.set('variant', select.value);
  history.replaceState({}, '', url);
  const image = section.querySelector('[id$="-' + option.dataset.media + '"]');
  if (image) image.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'nearest'});
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.mobile-menu[open], .nav-dropdown[open], .filter[open]').forEach((detail) => {
    detail.open = false;
    detail.querySelector('summary').focus();
  });
});

